import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaTiepCongDanPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='TIEP_CONG_DAN'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaTiepCongDanPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaTiepCongDanPage.jsx